export class GetNewDnpLinkInput {
    requesterName: string;
    expirationDate: string;
}